import { Injectable } from '@angular/core';
import { ICardUserVariant } from '../../model/i-card';

export interface ITrainingAnswer extends ICardUserVariant {
  class?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TrainingMode {
  className: string = '';
  listVariant: ITrainingAnswer[] = [];

  checkingCorrectnessAnswer(
    maxPoints: number,
    type: string,
    lists: ITrainingAnswer[],
  ): ITrainingAnswer[] {

    this.listVariant = lists;
    switch (type) {
      case 'checkbox':
        this.checkBoxType();
        break;
      case 'radiobutton':
        this.radioButtonType(maxPoints);
        break;
      default:
        break;
    }

    return this.listVariant;
  }

  checkBoxType(): void {
      this.listVariant.forEach((item) =>{
        if(item.variant){
          if(item.v_points < 0){
            item.class = 'oops point-event';
          }
          if(item.v_points > 0){
            item.class = 'hooray point-event variant-true';
          }
        }else{
          if(item.v_points > 0){
            item.class = 'hooray point-event variant-false';
          }else{
            item.class = 'point-event';
          }
        }
      });
  }

  radioButtonType(maxPoints: number): void {
    this.listVariant.forEach((item) =>{
        if(item.variant){
          if(item.v_points < 0){
            item.class = 'rd-oops point-event';
          }
          if(item.v_points === maxPoints){
            item.class = 'hooray point-event';
          }
          if(item.v_points < maxPoints && item.v_points > 0){
            item.class = 'so-so point-event';
          }
        }else{
          if(item.v_points > 0){
            item.class = 'point-event variant-false';
          }else{
            item.class = 'point-event';
          }
          //if(item.v_points === maxPoints){
            //item.class = 'point-event'; // hooray
          //}
        }
      });

  }
  
}
